import { makeStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import { Typography } from '@material-ui/core'
import { faBolt, faFistRaised, faGhost, faMap, faSkull, faToriiGate } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import View from '../View'
import HeroButton from 'helpers/HeroButton'

const useStyles = makeStyles((theme) => ({
    root: {},
    centered: {
        display: 'flex',
        justifyContent: 'center',
    }
}))

const Intro = () => {
    const classes = useStyles()
    return (
        <View title="Intro" header="The Ninja Game at Ninjawars.net">
            <Typography variant="subtitle1" color="secondary">
                Live by the Shuriken!
            </Typography>
            <p>
                The game is mainly one of fighting against other ninja. Once you
                are a ninja, you can:
                <ul>
                    <li>
                        <Icon icon={faBolt} /> <Link to='fight'>Attack townsfolk</Link> like the thief, villager, or
                        merchant.
                    </li>
                    <li>
                        <Icon icon={faSkull} /> Kill other ninja! Fight &gt;&gt; Pick ninja nearby, or
                        click the ninjas page.
                    </li>
                    <li>
                        <Icon icon={faFistRaised} /> Use your <Link to='skills'>skills</Link> or items to make more effective attacks.
                    </li>
                    <li>
                        <Icon icon={faGhost} /> If you die, just drag your ghost to the <Link to='shrine'><Icon icon={faToriiGate} /> shrine</Link> and the
                        monks will bring you back (click the resurrect link)
                    </li>
                </ul>
            </p>
            <p>
                You can <Link to='shop'>石 buy items</Link> to help your attack at the shop, but
                you&apos;ll need to work in the <Link to='map'><Icon icon={faMap} /> fields</Link> to get gold to afford
                anything. Once you get enough kills, you can level up at the
                dojo.
            </p>
            <div className={classes.centered}>
                <HeroButton to='fight'>Play</HeroButton>
            </div>
        </View>
    )
}

export default Intro
